let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("17m16")).then(() => parcelRequire('cdNFz'));